import parse from "html-react-parser"
import React from "react"

import JobOffersList from "./list/JobOffers"
import RichText from "./richText/Parser"

export default function JobOffers({ component, locale }) {
  const { richtitle, subtitle } = component
  return (
    <div className="relative bg-charlestonGreen-100">
      <div className="pt-12 pb-12 sm:pb-24">
        <div className="max-w-md pl-4 pr-4 mx-auto sm:max-w-lg sm:px-6 lg:max-w-7xl lg:px-8">
          {richtitle && (
            <RichText option="sectionTitle" stringHtml={richtitle} />
          )}
          {subtitle && <p className="mt-4 text-gray-500">{parse(subtitle)}</p>}
          <JobOffersList locale={locale} />
        </div>
      </div>
    </div>
  )
}
